import type { FC } from 'react';
import { useState } from 'react';
import {
  TableRow,
  TableCell,
  IconButton,
  Collapse,
  Table,
  TableBody,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { numberToMillons } from 'src/utils/functions';

const KpiRemesaFuvexRow: FC<{ item: any }> = ({ item }) => {
  const [open, setOpen] = useState(item.detail?.open || false);
  const keyDetail = `detail-fuvex-h-${item.id}`;

  return (
    <>
      <TableRow key={item.fuvex}>
        <TableCell style={{ padding: '2px' }}>
          {item.fuvex}
          {item.detail && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell align="right">{numberToMillons(item.facturacion)}</TableCell>
        <TableCell align="right">{numberToMillons(item.mejorMesDia)}</TableCell>
        <TableCell align="right">{numberToMillons(item.mejorMes)}</TableCell>
        <TableCell align="center" style={{ padding: '0px' }}>
          {item.comparativo}
          %
        </TableCell>
        <TableCell align="center">
          {item.avance}
          %
        </TableCell>
        <TableCell>
          <img
            src={`/static/images/${item.semaforo}.png`}
            alt={item.semaforo}
          />
        </TableCell>
      </TableRow>
      {item.detail && (
        <>
          <TableRow key={keyDetail}>
            <TableCell
              colSpan={7}
              style={{ display: open ? 'table-cell' : 'none', padding: 0 }}
            >
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Table
                  size="small"
                  style={{ background: 'white' }}
                  className="zoomin"
                >
                  <TableBody>
                    {item.detail?.data?.map((detail) => (
                      <TableRow key={detail.id}>
                        <TableCell width={240}>{detail.name}</TableCell>
                        <TableCell align="right">
                          {detail.facturacion}
                        </TableCell>
                        <TableCell align="right">
                          {detail.mejorMesDia}
                        </TableCell>
                        <TableCell align="right">{detail.mejorMes}</TableCell>
                        <TableCell align="center">
                          {item.comparativo}
                          %
                        </TableCell>
                        <TableCell align="center">
                          {item.avance}
                          %
                        </TableCell>
                        <TableCell align="center">
                          <img
                            src={`/static/images/${detail.semaforo}.png`}
                            alt={detail.semaforo}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Collapse>
            </TableCell>
          </TableRow>
        </>
      )}
    </>
  );
};

export default KpiRemesaFuvexRow;
